<svg width="0" height="0" style="position: absolute;">
  <defs>
    <clipPath id="shape-mask" clipPathUnits="objectBoundingBox">
      <path d="M0.077,0 H0.923 C0.965,0 1,0.035 1,0.077 V0.78 C1,0.822 0.965,0.857 0.923,0.857 H0.78 C0.738,0.857 0.703,0.892 0.703,0.934 V0.923 C0.703,0.965 0.668,1 0.626,1 H0.077 C0.035,1 0,0.965 0,0.923 V0.077 C0,0.035 0.035,0 0.077,0 Z" />
    </clipPath>
  </defs>
</svg>

<main class="flex min-h-screen items-center justify-between bg-gradient-to-r from-lBlack to-lBlue700 px-4">
  <section class="flex w-full flex-col items-center justify-center lg:max-w-[40%]">
    <img class="mx-auto mb-5" src="assets/images/unico-logo.svg" alt="uni:co." width="130" />

    @if (resetSucceeded) {
      <div class="space-y-2 text-center">
        <h1 class="text-2xl font-semibold text-lWhite">Senha redefinida com sucesso!</h1>
        <p class="text-sm text-lSecondary">Acesse sua conta e explore um mundo de possibilidades</p>
      </div>

      <div class="mx-auto mt-8 w-full lg:max-w-[30rem]">
        <button
          lButton
          type="button"
          [bType]="buttonTypes.PRIMARY"
          [bRadius]="buttonRadius.LARGE"
          (click)="goToLogin()"
        >
          Acessar tela de login
        </button>
      </div>
    } @else {
      <div class="space-y-2 text-center">
        <h1 class="text-2xl font-semibold text-lWhite">Redefinir senha</h1>
        <p class="text-sm text-lSecondary">Acesse sua conta e explore um mundo de possibilidades</p>
      </div>

      <form
        class="mx-auto mt-8 w-full animate-fadeIn lg:max-w-[30rem]"
        [formGroup]="form"
        (submit)="submit()"
        autocomplete="off"
      >
        <div class="space-y-6">
          <div class="space-y-2">
            <label class="text-sm font-medium text-lSecondary" for="password">Senha</label>
            <div class="form-input relative flex items-center">
              <l-icon class="form-input--icon">lock</l-icon>
              <input
                type="password"
                [type]="hidePassword ? 'password' : 'text'"
                id="password"
                formControlName="password"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-lSecondary transition-colors hover:text-lWhite"
                aria-label="Mostrar senha"
                (click)="hidePassword = !hidePassword"
              >
                <l-icon class="mt-2 text-base font-normal">{{ hidePassword ? 'visibility_off' : 'visibility' }}</l-icon>
              </button>
            </div>
          </div>

          <div class="space-y-2">
            <label class="text-sm font-medium text-lSecondary" for="confirm-password">Confirmar senha</label>
            <div class="form-input relative flex items-center">
              <l-icon class="form-input--icon">lock</l-icon>
              <input
                type="password"
                [type]="hideConfirmPassword ? 'password' : 'text'"
                id="confirm-password"
                formControlName="confirmPassword"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-lSecondary transition-colors hover:text-lWhite"
                aria-label="Mostrar confirmação da senha"
                (click)="hideConfirmPassword = !hideConfirmPassword"
              >
                <l-icon class="mt-2 text-base font-normal">{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</l-icon>
              </button>
            </div>

            <l-password-feedback
              [password]="form.controls.password.value"
              [confirmPassword]="form.controls.confirmPassword.value"
            />
          </div>

          <button
            lButton
            type="submit"
            [disabled]="isLoading"
            [bType]="buttonTypes.PRIMARY"
            [bRadius]="buttonRadius.LARGE"
          >
            @if (isLoading) {
              <l-spinner [size]="spinnerSize.SMALL" [color]="spinnerColors.WHITE" />
            }
            <span>Entrar</span>
          </button>
        </div>
      </form>
    }
  </section>

  <aside class="hidden h-screen flex-1 items-center justify-center lg:flex">
    <div class="relative h-[95%] w-[95%]">
      <div class="shape-card h-full w-full"></div>

      <l-animated-banner class="pointer-events-none absolute inset-0 z-10" />

      <div class="gradient-border absolute bottom-[20%] left-[5%] z-20 lg:bottom-[25%] lg:left-[10%] xl:bottom-[30%]">
        <span class="text-sm font-semibold text-lWhite lg:text-base xl:text-lg 2xl:text-xl">Educação Corporativa</span>
      </div>
      <div class="gradient-border absolute bottom-[10%] left-0 z-20 lg:bottom-[15%] xl:bottom-[20%]">
        <span class="text-sm font-semibold text-lWhite lg:text-base xl:text-lg 2xl:text-xl">Treinamentos e workshops</span>
      </div>

      <img src="assets/images/unico-logo.svg" alt="uni:co." class="absolute bottom-[5%] right-[7%] z-10 w-[15%] min-w-28" />
    </div>
  </aside>
</main>
